"use strict";

exports.__esModule = true;
exports.useId = useId;

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function useId(idProp) {
  var _React$useState = React.useState(''),
      id = _React$useState[0],
      setId = _React$useState[1];

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    setId((0, _lodash["default"])());
  }, []);
  return React.useMemo(function () {
    return idProp != null ? idProp : "manifestui-id-" + id;
  }, [id, idProp]);
}